<template>
	<main>
		<banner :title="getText('lnb-name')"/>

		<section class="bg-gray-700">
			<div class="container mx-auto px-4 pb-16 md:pb-48">
				<div class="flex flex-wrap">
					<div class="text-left pt-12 w-full">
						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('p-name-3') }}</h2>
						</div>
						<div class="flex flex-wrap">
							<div class="w-full md:w-6/12">
								<div class="block mb-4">

									<p class="text-white font-semibold mb-4">{{ getText('p-location-3') }}</p>

									<div class="text-white font-semibold">
										<p class="pb-4">{{ getText('lnb-description-more') }}</p>
									</div>

									<p class="text-white mb-4">
										<span class="font-semibold">{{ getText('client') }}: </span>
										<span>{{ getText('p-client-3')}}</span>
									</p>

									<div class="text-white pb-4">
										<p class="font-semibold">{{ getText('project-group') }}:</p>
										<ul>
											<li v-for="partner in partners" :key="partner" class="flex">
												<i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
												<span class="pt-2">{{ getText(partner) }}</span>
											</li>
										</ul>
									</div>

									<p class="text-white pb-4">
										<span class="font-semibold">{{ getText('object-building') }}: </span>
										<span>2008 - 2014</span>
									</p>

									<p class="text-white pb-4">
										<span class="font-semibold">{{ getText('object-supervision') }}: </span>
										<span>„Hill International N.V.”</span>
									</p>

									<p class="text-white pb-4">
										<span class="font-semibold">{{ getText('object-author-supervision') }}: </span>
										<span>„Hill International Baltic” (M. Mežulis), „Arhitektu birojs Ģelzis-Šmits-Arhetips” (“GSA projekts”) (M.Mežulis); “Arhetips” (M.Mežulis, A.Arbidāns), “Arhitekta Modra Ģelža birojs” (S.Laganovska)</span>
									</p>

									<p class="text-white pb-4">
										<span class="font-semibold">{{ getText('contractor') }}: </span>
										<span>{{ getText('lnb-contractor') }}</span>
									</p>

									<p class="text-white pb-4">
										<span class="font-semibold">{{ getText('object-interior') }}: </span>
										<span>{{ getText('lnb-interior') }}</span>
									</p>

									<div class="text-white font-semibold pb-4">
										<p class="text-white font-semibold mt-4">{{ getText('object-description') }}</p>
										<ul>
											<li class="flex">
												<i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
												<span class="pt-2">{{ getText('object-total-area') }}: 40 455 m²</span>
											</li>
											<li class="flex">
												<i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
												<span class="pt-2">{{ getText('object-construction-area') }}: 17 431 m²</span>
											</li>
											<li class="flex">
												<i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
												<span class="pt-2">{{ getText('lnb-tech') }}</span>
											</li>
											<li class="flex">
												<i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
												<span class="pt-2">{{ getText('object-volume') }}: 263 000 m³</span>
											</li>
										</ul>
									</div>

									<div class="text-white font-semibold">
										<p class="pb-4">{{ getText('object-costs') }}: {{ getText('lnb-costs') }}</p>
									</div>

									<div class="pt-4">
								<span class="text-white font-semibold">
									{{ getText('additional-information') }}:
								</span>
										<a class="underline text-white font-semibold" href="https://www.lnb.lv">
											LNB.lv
										</a>
									</div>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-12">
								<slider :images="slidesLnb"></slider>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
	import {LNB_PARTNERS} from '../../data/projectPartners'
	import {mapGetters} from "vuex";
	import Slider from '../../components/Slider.vue';
	import Banner from "../Banner";

	export default {
		name: "Lnb",
		data() {
			return {
				partners: LNB_PARTNERS,
				slidesLnb: [
					'/images/lnb/lnb-1.jpg',
					'/images/lnb/lnb-2.jpg',
					'/images/lnb/lnb-6-2.jpg',
					'/images/lnb/lnb-6.jpg',
					'/images/lnb/lnb-7.jpg',
					'/images/lnb/lnb-8.jpg',
				],
			}
		},
		computed: {
			...mapGetters(['getText'])
		},
		components: {
			Banner,
			Slider,
		},
	}
</script>

<style scoped>

</style>